module.exports = __webpack_public_path__ + "static/img/Gini-product-2.ff67a08.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/Gini-product-2.png
// module id = UQEv
// module chunks = 1